import { useState } from "react";

// The "Excluded dates" value in a habit's details panel. Up to
// EXCLUDED_PREVIEW_COUNT dates show as they are; past that the list stops with
// "…" and a "See more" link that shows the rest ("See less" folds it back).
// Its own component, not inline in the panel, so the open/closed state isn't
// reset by the panel's re-renders (its row components are rebuilt each time).
export const EXCLUDED_PREVIEW_COUNT = 5; // Jade, 2026-10-09: at least 5 before "See more"

// "Dec 25" this year, "Jan 1, 2027" otherwise — keeps the line short.
export function excludedDateLabel(ds, thisYear = new Date().getFullYear()) {
  const d = new Date(ds + "T00:00:00");
  const opts = d.getFullYear() === thisYear
    ? { month: "short", day: "numeric" }
    : { month: "short", day: "numeric", year: "numeric" };
  return d.toLocaleDateString("en-US", opts);
}

export function ExcludedDatesValue({ dates }) {
  const [open, setOpen] = useState(false);
  const list = [...new Set(dates || [])].sort();
  if (!list.length) return null;
  const long = list.length > EXCLUDED_PREVIEW_COUNT;
  const shown = long && !open ? list.slice(0, EXCLUDED_PREVIEW_COUNT) : list;
  return (
    <span>
      {shown.map(ds => excludedDateLabel(ds)).join(" · ")}
      {long && !open && "…"}
      {long && " "}
      {long && (
        <button type="button" onClick={(e) => { e.stopPropagation(); setOpen(o => !o); }}
          style={{ background: "none", border: "none", boxShadow: "none", padding: 0, margin: "0 0 0 2px", minHeight: 0, minWidth: 0, cursor: "pointer", fontFamily: "inherit", fontSize: 12, fontWeight: 700, color: "var(--c-text-accent)", textDecoration: "underline", whiteSpace: "nowrap" }}>
          {open ? "See less" : "See more"}
        </button>
      )}
    </span>
  );
}
